import React, { useContext } from "react";

// global state
import { StateContext } from "../../AppStateContext";

//styling
import "./AddNewClassModals.css";

// schema add class state
import {
  SchemaAddClassStateContext,
  SchemaAddClassStateDispatchContext,
} from "./SchemaAddClassStateContext";

// Styling
import "./AddNewClassModals.css";

// To make the component fade in once rendered
import FadeIn from "react-fade-in";

// Material UI imports
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";

const AddNewPropertyModalContent = ({
  setIsClassAdvancedSettingsModalOpen,
}) => {
  // global state
  const state = useContext(StateContext);

  // consume add class state
  const schemaState = useContext(SchemaAddClassStateContext);
  const schemaSetState = useContext(SchemaAddClassStateDispatchContext);

  const isVectorized = (e) => {
    if (e.target.checked) {
      schemaSetState({ ...schemaState, vectorizeClassName: true });
    } else {
      schemaSetState({ ...schemaState, vectorizeClassName: false });
    }
  };

  const closeModal = () => {
    setIsClassAdvancedSettingsModalOpen(false);
  };

  return (
    <FadeIn transitionDuration={600}>
      <div
        className={
          state.theme === "dark"
            ? "__addNewClassAdvancedSettingsModalContent __addNewClassAdvancedSettingsModalContentDark"
            : "__addNewClassAdvancedSettingsModalContent __addNewClassAdvancedSettingsModalContentLight"
        }
      >
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            <label
              htmlFor="vectorizePropertyNameCheckbox"
              value="Vectorize Property Name"
              style={{
                color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
                fontWeight: "200",
                fontFamily: "Alegreya Sans, sans-serif !important",
                fontSize: "18px",
                marginTop: "11px",
                marginLeft: "11px",
                marginRight: "30px",
              }}
            >
              Vectorize Class Name
            </label>{" "}
            <Checkbox
              style={{ color: "fa0171" }}
              id="vectorizePropertyNameCheckbox"
              onChange={isVectorized}
            />
          </FormGroup>
        </FormControl>
        <button
          className={
            state.theme === "dark"
              ? "__addNewClassAdvancedSettingsSaveButton __addNewClassAdvancedSettingsSaveButtonDark"
              : "__addNewClassAdvancedSettingsSaveButton __addNewClassAdvancedSettingsSaveButtonLight"
          }
          onClick={closeModal}
          id="addNewClassAdvancedSettingsSave"
        >
          Save
        </button>
      </div>
    </FadeIn>
  );
};

export default AddNewPropertyModalContent;
